import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  // 1. where to load translations from (folder per lang)
  .use(HttpBackend)
  // 2. auto-detect the browser / user language
  .use(LanguageDetector)
  // 3. hook into React
  .use(initReactI18next)
  .init({
    fallbackLng: "en-GB",
    supportedLngs: ["en-GB", "en-US", "ja"], // keep this list short
    debug: process.env.NODE_ENV === "development",
    defaultNS: "common",
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // default
    },
  });

export default i18n; // ⇠ just importing this file runs init()
